import { FullCustomGroup } from "../models/DepartmentData/CustomGroup";
import { Declarant } from "../models/Declarant";
import { Item } from "../models/DepartmentData/Item";
import { Client as IClient } from "../models/ByClients/Client";

export const CUSTOM_GROUP_PREFIX = "custom_group-";

export function isCustomGroupKey(key: string) {
  return key.startsWith(CUSTOM_GROUP_PREFIX);
}

export function isCustomGroup(
  entity: Declarant | IClient | Item
): entity is FullCustomGroup {
  if (!("id" in entity)) {
    return false;
  }

  if (typeof entity.id !== "string") {
    return false;
  }

  return isCustomGroupKey(entity.id);
}
